<template>
  <b-container fluid>
    <b-form>
      <b-form-group>
        <b-form-select v-model="selected" v-bind:options="files.options"></b-form-select>
      </b-form-group>
      <b-form-group>
        <b-button variant="primary" @click="download">Download</b-button>
      </b-form-group>
    </b-form>
  </b-container>
</template>

<script>

import store from '@/store'

export default {
  name: 'DownloadRelatedFiles',
  props: ['type', 'sono'],
  data () {
    return {
      selected: null
    }
  },
  computed: {
    files () {
      let files = null
      switch (this.type) {
        case 'salesOrder': files = store.state.sales_orders.files; break
        default: files = null
      }
      return files
    }
  },
  methods: {
    download () {
      store.dispatch('files/downloadFile', this.selected).then((response) => {
        // Get the file details.
        const filename = response.data.filename
        const mimetype = response.data.mimetype
        let filedata = atob(response.data.filedata)

        // Convert non-text file contents.
        if (!mimetype.includes('text')) {
          // Create an array of char-codes.
          const c = filedata.length
          let ccArray = new Array(c)
          for (let i = 0; i < c; i++) {
            ccArray[i] = filedata.charCodeAt(i)
          }

          // Create a byte array.
          filedata = new Uint8Array(ccArray)
        }

        // Create a blob.
        const blob = new Blob([filedata], {type: mimetype})
        const link = document.createElement('a')

        // "Click" the download link
        link.href = URL.createObjectURL(blob)
        link.download = filename
        link.click()
        URL.revokeObjectURL(link.href)
      })
    }
  },
  beforeMount () {
    switch (this.type) {
      case 'salesOrder': store.dispatch('sales_orders/fetchRelatedSalesOrderFiles', this.sono.trim()); break
    }
  }
}
</script>

<style scoped>

</style>
